import React from "react";
import classnames from "classnames";
import { FlightInformation, RountTrip } from "../../../components";
import { renderRecordValue } from "../../../utils";
import { STATUSES_STYLING } from "../../../constants/styles/statuses";
import {
  formatUberTripStatusLabel,
  getRiderActualHeightForBariaticVehicleType,
  getRiderActualWeightForBariaticVehicleType,
  getRideStatusLabel,
  getUberDriverWaitMinutesFromRecord,
} from "../../../utils/helpers";

import styles from "./index.module.css";
import { vehicleOptionsDictionary } from "../../../dictionaries";
import { Popover, Tag } from "antd";
import { OverNight } from "../../../components/common/OverNight/OverNight";
import { rescheduleMessage, mhAdminRescheduleMessage, RIDE_STATUSES, UBER_TEXT, URLS } from "../../../constants/constants";
import { RescheduleRideIcon } from "../../../components/common/RescheduleRideIcon/RescheduleRideIcon";
import classNames from "classnames";
import { PatientSpecialAccommodationsIcon } from "../../../components/common/SpecialAccommodationIcon/SpecialAccommodationIcon";
import { FrequentFlyerPatientIcon } from "../../../components/common/FrequentFlyerPatientIcon/FrequentFlyerIcon";
import { UberHealthTag } from "../../../components/common/UberHealthTag/UberHealthTag";
import reRequestIcon from "../../../assets/svgs/reRequestIcon.svg";
import { Navigation } from "../../../utils/navigation";

export const renderColumns = (navigate) => {
  return [
    {
      title: "Organization",
      dataIndex: "healthOrganizationName",
      key: "healthOrganizationName",
      width: 180,
      render: (text) => (
        <div
          className={classnames({
            [styles.organizationCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text?.split("_").join(" "))}
        </div>
      ),
    },


    {
      title: "Ride ID",
      dataIndex: "seqId",
      key: "seqId",
      width: 155,
      render: (text, record) => (
        <div
          className={classnames({

            [styles.cellValue]: true,
          })}
        >

          {record?.flightInfo ? (
            <Popover
              content={<FlightInformation flightInfo={record?.flightInfo} />}
              placement="topLeft"
              getPopupContainer={() => document.querySelector(".ant-table")}
            >
              <span style={{ color: "blue", textDecorationLine: "underline" }}>
                {renderRecordValue(text)}
              </span>
            </Popover>
          ) : (
            renderRecordValue(text)
          )}

          {record?.isReRequested && (
            <div className={styles.uberNoShowCell}>
              <Tag className={styles.uberReRequestedTag}>
                Re-Requested
              </Tag>
            </div>
          )}

          <br />
          <div className={styles.dflex}>

            <OverNight record={record} />
            <RountTrip record={record} />


            {(record?.status === RIDE_STATUSES.RESCHEDULED || record?.rescheduledFrom) && <RescheduleRideIcon />}
          </div>
        </div>
      ),
    },

    {
      title: "Rider Name",
      dataIndex: "rider",
      key: "rider",
      width: 150,
      render: (text, record) => (
        <div
          className={classnames({
            [styles.riderCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          <span style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            {renderRecordValue(text)}
            {record.riderInfo?.specialAccommodations && <PatientSpecialAccommodationsIcon specialNeeds={record?.riderInfo?.specialAccommodationsNeeds || null} />}
            {record.riderInfo?.frequentFlyer && <FrequentFlyerPatientIcon fill="#E1F4D3" />}
          </span>
        </div>
      ),
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
      width: 250,
      render: (text, record) => (
        <>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
            })}
          >
            {renderRecordValue(vehicleOptionsDictionary[text])}
            {text === 'uberAmbulatoryRide' && <UberHealthTag />}
            {text === 'uberAmbulatoryRide' && record?.uberInfo?.uberStatus && (
              <div
                className={styles.uberListTripLine}
                title={record.uberInfo.uberRideId ? `Uber trip ${record.uberInfo.uberRideId}` : undefined}
              >
                {formatUberTripStatusLabel(record.uberInfo.uberStatus)}
                {record.uberInfo.driverInfo?.name && (
                  <span>{` · ${record.uberInfo.driverInfo.name}`}</span>
                )}
              </div>
            )}
          </div>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
              [styles.actualWeight]: true,
            })}
          >
            <div> {getRiderActualWeightForBariaticVehicleType(text, record)}</div>
            <div> {getRiderActualHeightForBariaticVehicleType(text, record)}</div>
          </div>
        </>
      ),
    },

    {
      title: "Pickup Date",
      dataIndex: "pickUpDate",
      key: "pickUpDate",
      width: 200,
      render: (value) => (
        <div
          className={classnames({
            [styles.pickUpDateCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(value)}
        </div>
      ),
    },

    {
      title: "Ride Status",
      dataIndex: "readableStatus",
      key: "readableStatus",
      width: 220,
      render: (text, record) => {
        const driverWaitMins = getUberDriverWaitMinutesFromRecord(record);
        return (
        <div
          className={classnames({
            [styles.statusCellValue]: true,
            [styles.cellValue]: true,
            [STATUSES_STYLING[text]]: true,
          })}
        >
          {text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase() ||
          record?.rescheduledFrom ? (
            <Popover
              content={
                text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase()
                  ? mhAdminRescheduleMessage
                  : `Rescheduled Ride`
              }
              overlayClassName={classNames({
                [styles.overlay]: true,
              })}
              getPopupContainer={(trigger) => document.body}
            >
              <div>
                {renderRecordValue(getRideStatusLabel(text, RIDE_STATUSES.CANCELED))}
              </div>
            </Popover>
          ) : (
            <>
              {renderRecordValue(getRideStatusLabel(text, RIDE_STATUSES.CANCELED))}
              {record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL && (
                <div className={styles.uberNoShowText}>
                  No-show
                  {typeof driverWaitMins === "number" && driverWaitMins > 0 && (
                      <>
                        {" "}
                        | Driver wait {driverWaitMins} min
                        {driverWaitMins > 1 ? "s" : ""}
                      </>
                    )}
                </div>
              )}
            </>
          )}
        </div>
      );
      },
    },
    {
      title: "Recurring",
      dataIndex: "recurringRideIndex",
      key: "recurringRideIndex",
      width: 120,
      render: (text, record) => {
        const hasIcon = record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL;
        const showReRequestIcon = hasIcon && !record?.isReRequested;
        const hasIndex = !!record?.recurringRideIndex;
        return (
          <div
            className={classnames({
              [styles.recurringInfo]: true,
              [styles.recurringCellValue]: true,
              [styles.lastRide]: record.isLastRecurring,
            })}
          >
            {hasIndex
              ? renderRecordValue(record.recurringRideIndex)
              : !hasIcon
              ? "-"
              : null}
            {showReRequestIcon && (
              <span
                className={styles.reRequestIconWrapper}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate.push(
                    URLS.UBER_RESCHEDULE_RIDE.replace(":id", record.id),
                  );
                }}
                title={UBER_TEXT.TOOLTIP_REREQUEST_NEW_UBER_RIDE}
              >
                <img
                  src={reRequestIcon}
                  alt="Re-request Uber ride"
                  width={21}
                  height={21}
                  className={styles.reRequestIcon}
                />
              </span>
            )}
          </div>
        );
      },
    },
  ];
};
